import styled from 'styled-components';
import tw from 'twin.macro';
import SVGIcon from '../../components/SVGIcon/SVGIcon';
import { Meta, Subhead } from '../../styled components/Typography';

export const TimesheetStatus = styled.div(() => [tw`flex items-center gap-x-4`]);

export const TimesheetStatusLabel = styled(Subhead)(({ $variant }) => [
  tw`inline-block text-black text-opacity-60`,
  ($variant === 'approved' || $variant === 'finalized') && tw` text-blue-base `,
  $variant === 'rejected' && tw` text-red-base `
]);

export const TimesheetStatusIcon = styled(SVGIcon).attrs(() => ({}))(({ variant }) => [
  (variant === 'approved' || variant === 'finalized') && tw` text-blue-base `,
  variant === 'rejected' && tw` text-red-base `
]);

export const TimesheetMinorStatus = styled(Meta).attrs(({ $showAsInlineMessage }) => ({
  $color: $showAsInlineMessage ? 'gray dark' : 'gray light'
}))(({ $isDraftStatus, $showAsInlineMessage }) => [
  !$showAsInlineMessage && $isDraftStatus && tw`text-red-base`
]);